import React from 'react'
import { Box, Tooltip } from '@mui/material'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart'
import MouseIcon from '@mui/icons-material/Mouse'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { TRADE_EXIT_TOOLTIP, TradeExitKind } from '../utils/tradeExit'

const EXIT_ICONS: Record<TradeExitKind, React.ElementType> = {
  exitPattern: AccountTreeIcon,
  tpSl: CandlestickChartIcon,
  forceExit: ScheduleIcon,
  manual: MouseIcon,
}

interface TradeExitIconProps {
  exitKind: TradeExitKind | null
  size?: number
}

// Small icon explaining how a closed trade exited; renders nothing for open/rejected trades
const TradeExitIcon: React.FC<TradeExitIconProps> = ({ exitKind, size = 16 }) => {
  if (!exitKind) return null
  const Icon = EXIT_ICONS[exitKind]
  return (
    <Tooltip title={TRADE_EXIT_TOOLTIP[exitKind]} arrow>
      <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <Icon sx={{ color: 'text.secondary', fontSize: size }} />
      </Box>
    </Tooltip>
  )
}

export default TradeExitIcon
